import { AxiosInstance, AxiosResponse, AxiosRequestConfig } from "axios"

export interface BookingModificationRequest
  extends Partial<AxiosRequestConfig> {
  params: {
    bookingNumber: string
    message: string
  }
}

export interface BookingModificationResponseData extends AxiosResponse {
  data: any
}

export interface BookingModificationResponse
  extends BookingModificationResponseData {
  data: any
}

export function bookingModificationRequestApi(
  { params }: BookingModificationRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    data: params,
    method: "post",
    url: "/email/booking-modification-request",
  }) as Promise<BookingModificationResponse>
}
